import { IMAGE_BUCKET } from '../imageManagement/imageStoragePaths';

export const AD_CARDS_BUCKET = IMAGE_BUCKET;
export const AD_CARDS_MAX_ACTIVE = 5;
export const AD_CARDS_MAX_BYTES = 1000 * 1024; // 1000KB
export const AD_CARDS_ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];

/** 오늘(Asia/Seoul) YYYYMMDD */
export const todayYmdSeoul = () => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const y = parts.find((p) => p.type === 'year')?.value || '';
  const m = parts.find((p) => p.type === 'month')?.value || '';
  const d = parts.find((p) => p.type === 'day')?.value || '';
  return `${y}${m}${d}`;
};

export const ymdToDateInput = (ymd) => {
  if (!ymd || String(ymd).length !== 8) return '';
  const s = String(ymd);
  return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
};

export const dateInputToYmd = (value) => (value ? String(value).replace(/-/g, '') : '');

export const formatYmdDisplay = (ymd) => ymdToDateInput(ymd) || '-';

/** 종료일 경과 여부 (end_ymd < 오늘) */
export const isExpiredByEndDate = (endYmd, todayYmd = todayYmdSeoul()) => {
  if (!endYmd || String(endYmd).length !== 8) return false;
  return String(endYmd) < todayYmd;
};

/** 목록/상세에 표시할 실효 활성 여부 */
export const isEffectivelyActive = (item, todayYmd = todayYmdSeoul()) => {
  if (!item || item.is_active !== 'Y') return false;
  if (isExpiredByEndDate(item.end_ymd, todayYmd)) return false;
  return true;
};

/**
 * 목록 정렬: 활성(실효) → sort_no 오름차순, 비활성 → 등록일(created_at) 최신순
 */
export const sortAdCardListItems = (items, todayYmd = todayYmdSeoul()) => {
  const list = Array.isArray(items) ? [...items] : [];
  return list.sort((a, b) => {
    const aActive = isEffectivelyActive(a, todayYmd);
    const bActive = isEffectivelyActive(b, todayYmd);
    if (aActive !== bActive) return aActive ? -1 : 1;

    if (aActive) {
      const sortDiff = (Number(a.sort_no) || 0) - (Number(b.sort_no) || 0);
      if (sortDiff !== 0) return sortDiff;
    }

    const aCreated = new Date(a.created_at || 0).getTime();
    const bCreated = new Date(b.created_at || 0).getTime();
    return bCreated - aCreated;
  });
};

export const getPublicImageUrl = (supabase, storagePath, cacheKey) => {
  if (!storagePath) return '';
  const { data } = supabase.storage.from(AD_CARDS_BUCKET).getPublicUrl(storagePath);
  const base = data?.publicUrl || '';
  if (!base) return '';
  const v = cacheKey || '1';
  return `${base}${base.includes('?') ? '&' : '?'}v=${encodeURIComponent(v)}`;
};

export const buildAdCardStoragePath = (id, fileName, kind = 'card') => {
  const safeName = String(fileName || 'ad.png')
    .replace(/[^\w.\-]+/g, '_')
    .replace(/_+/g, '_');
  const prefix = kind === 'detail' ? 'detail_' : '';
  return `ad-cards/${id}/${prefix}${safeName}`;
};

export const AD_CARD_LINK_MENU_OPTIONS = [
  { value: '', label: '(없음)' },
  { value: 'bible_quiz', label: '바이블 퀴즈 (/bible_quiz)' },
  { value: 'scripture_quiz', label: '성경 퀴즈 (/scripture_quiz)' },
  { value: 'bible_reading', label: '성경읽기 (/bible_reading)' },
  { value: 'prayer_note', label: '기도노트 (/prayer_note)' },
  { value: 'bible_study', label: '성경공부 (/bible_study)' },
  { value: 'family_devotion', label: '가정예배 (/family_devotion)' },
  { value: 'gratitude_journal', label: '감사일기 (/gratitude_journal)' },
  { value: 'my_meditation_note', label: '나의 묵상노트 (/my_meditation_note)' },
  { value: 'subscribe', label: '구독 (/subscribe)' },
  { value: 'profile', label: '내 정보 (/profile)' },
  { value: 'calendar', label: '캘린더 (/calendar)' },
  { value: 'today_qt', label: '오늘의 QT (/today_qt)' },
  { value: 'qt_new', label: '묵상하기 (/qt_new)' },
  { value: 'inquiries', label: '문의 (/inquiries)' },
];

/** 외부 링크 URL 정규화 (http/https만 허용, 빈 값은 null) */
export const normalizeLinkUrl = (value) => {
  const trimmed = String(value || '').trim();
  if (!trimmed) return null;
  const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const url = new URL(withScheme);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    return url.toString();
  } catch {
    return null;
  }
};
